import {
  ApplicationDispatch,
  SET_SERVER_MESSAGE,
  SET_VEHICLE_JDPOWER
} from "../store/application/types";
import { fetchData, postData } from "./fetch";
import { AppState } from '../store/rootReducer';
import { IJDPowersportModel } from "../Interfaces/JDPower/IJDPowersportModel";
import {VehicleJdPower} from "@amsanalytics/react-shared-library";

// Motorcycle
export const getJdPowersportModels = async (dispatch: ApplicationDispatch, applicationId: string, vehicleId: string, vin: string) => {
  try {
    let url = `api/JDPower/getJDPowersportModels?applicationId=${applicationId}&vin=${vin}`;
    if (vehicleId) {
      url = `${url}&vehicleId=${vehicleId}`;
    }
    const result: { vehicleBaseId?: string, models: IJDPowersportModel[] } | { message: string } = await fetchData(url, dispatch);
    if ((result as { message: string }).message !== undefined) {
      console.log((result as { message: string }).message);
    } else {
      return result as { vehicleBaseId?: string, models: IJDPowersportModel[] };
    }
  } catch (err) {
    window.console.log('unknown error occurred')
    window.console.log('ERROR__', err);
    dispatch({
      type: SET_SERVER_MESSAGE,
      payload: { isError: true, message: err as string },
    });
  }
}

// Car
export const saveVehicleJdPower = (vehicleJdPower: VehicleJdPower, applicationId: string, isIndirectApplication: boolean) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/JDPower/saveVehicleJdPower`;
      const result: VehicleJdPower | { message: string } = await postData(url, { vehicleJdPower, applicationId, isIndirectApplication });
      if ((result as { message: string }).message !== undefined) {
        console.log((result as { message: string }).message);
      } else {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: false, message: "JD Power value saved successfully" },
        });
        dispatch({
          type: SET_VEHICLE_JDPOWER,
          payload: { vehicleJdPower: result as VehicleJdPower, isIndirectApplication }
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

